// extracted by mini-css-extract-plugin
module.exports = {"text":"ExpandedText_text__hdxRU","text__content":"ExpandedText_text__content__c1AmP","text__content__showMore":"ExpandedText_text__content__showMore__k9HiJ"};